import React, { useState, useEffect } from 'react';
import { Card } from './ui/card';
import { Play } from 'lucide-react';

const GallerySection = () => {
  const [selectedVideo, setSelectedVideo] = useState(null);
  
  const videos = [
    { 
      url: 'https://customer-assets-7cd3h4nn.emergentagent.net/job_41ad9bc8-daac-4809-894b-90c60487a24b/artifacts/dexuou02_Video-83831.mp4', 
      thumbnail: 'https://customer-assets-7cd3h4nn.emergentagent.net/job_41ad9bc8-daac-4809-894b-90c60487a24b/artifacts/oev5olnt_WhatsApp%20Image%202026-07-22%20at%2011.39.59%20%281%29.JPG',
      title: 'Child Playing with Rainbow Hoops' 
    },
    { 
      url: 'https://customer-assets-7cd3h4nn.emergentagent.net/job_41ad9bc8-daac-4809-894b-90c60487a24b/artifacts/8tpeujmn_Video-78045.mp4', 
      thumbnail: 'https://customer-assets-7cd3h4nn.emergentagent.net/job_41ad9bc8-daac-4809-894b-90c60487a24b/artifacts/kstr3631_WhatsApp%20Image%202026-07-22%20at%2011.40.04.jpeg',
      title: 'Teacher with Children on Play Mat' 
    },
    { 
      url: 'https://customer-assets-7cd3h4nn.emergentagent.net/job_41ad9bc8-daac-4809-894b-90c60487a24b/artifacts/xjsgtugw_WhatsApp%20Video%202026-07-27%20at%2013.01.52.mp4', 
      thumbnail: 'https://customer-assets-7cd3h4nn.emergentagent.net/job_41ad9bc8-daac-4809-894b-90c60487a24b/artifacts/heiai7vj_WhatsApp%20Image%202026-07-27%20at%2012.51.42%20%281%29.jpeg',
      title: 'Children Around Red Table' 
    },
  ];

  // Prevent body scroll when modal is open
  useEffect(() => {
    if (selectedVideo) {
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
      document.documentElement.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
      document.documentElement.style.overflow = 'unset';
    };
  }, [selectedVideo]);

  return (
    <section id="gallery" className="py-20" style={{ backgroundColor: 'var(--surface-cream)' }}>
      <div className="container mx-auto px-4 lg:px-8">
        <div className="max-w-7xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold heading-playful mb-4" style={{ color: 'var(--primary-orange)' }}>
              Gallery
            </h2>
            <p className="text-xl max-w-3xl mx-auto" style={{ color: 'var(--text-secondary)' }}>
              A glimpse of our vibrant learning spaces and happy moments.
            </p>
            <div className="w-24 h-1 mx-auto mt-4 rounded-full" style={{ backgroundColor: 'var(--primary-green)' }}></div>
          </div>

          {/* Video Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {videos.map((video, index) => (
              <Card
                key={index}
                className="overflow-hidden rounded-3xl border-0 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2 cursor-pointer relative group"
                style={{ backgroundColor: 'white' }}
                onClick={() => setSelectedVideo(video)}
              >
                <div className="relative h-72 overflow-hidden bg-gray-100">
                  {/* Video Thumbnail */}
                  <img 
                    src={video.thumbnail} 
                    alt={video.title}
                    className="w-full h-full object-cover"
                  />
                  {/* Play Overlay */}
                  <div className="absolute inset-0 bg-black/40 flex items-center justify-center group-hover:bg-black/50 transition-all duration-300 z-10">
                    <div className="w-20 h-20 rounded-full bg-white/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                      <Play className="h-10 w-10 ml-1" style={{ color: 'var(--primary-blue)' }} fill="currentColor" />
                    </div>
                  </div>
                </div>
              </Card>
            ))}
          </div>

          {/* Video Modal - HTML5 Video Player */}
          {selectedVideo && (
            <div 
              className="fixed inset-0 bg-black z-50 flex items-center justify-center video-modal"
              style={{ margin: 0, padding: 0 }}
              onClick={() => setSelectedVideo(null)}
            >
              <div className="relative w-full h-full flex items-center justify-center" onClick={(e) => e.stopPropagation()}>
                <button
                  onClick={() => setSelectedVideo(null)}
                  className="absolute top-4 right-4 z-50 w-12 h-12 rounded-full bg-white/90 hover:bg-white flex items-center justify-center shadow-lg"
                  style={{ margin: 0 }}
                >
                  <span className="text-3xl leading-none">×</span>
                </button>
                <div className="w-full h-full max-w-6xl max-h-screen flex items-center justify-center px-4 py-16">
                  <video
                    src={selectedVideo.url}
                    controls
                    autoPlay
                    className="w-full h-auto max-h-full rounded-lg"
                    style={{ maxHeight: 'calc(100vh - 128px)' }}
                  >
                    Your browser does not support the video tag.
                  </video>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default GallerySection;
